var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isAnalyzed(_vm.item.status) && _vm.result)?_c('td',{class:_vm.cefrStyleClass(_vm.cefrLevel),staticStyle:{"width":"300px"}},[_vm._v(" "+_vm._s(_vm.cefrLevel)+" ("+_vm._s(_vm.result.score)+") ")]):_c('td',{staticStyle:{"width":"300px"}},[_vm._v(_vm._s(_vm.getStatus()))])
}
var staticRenderFns = []

export { render, staticRenderFns }